import { CanActivate, UrlTree } from '@angular/router';
import { AuthenticationFacade } from '../+state/authentication.facade';
import { Observable, combineLatest, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src/lib/+state/company-config.facade';
import { NavController } from '@ionic/angular';
import { AccountDetailsFlowType } from '../enum';
// import { ScanQROrderFacade } from '@symphony-solo/domain/scan-qr-order/src';
import { catchError, first, map } from 'rxjs/operators';
// import { Tile } from '@symphony-solo/shared/components/src/lib/models/tile.model';

@Injectable()
export class ValidateUserGuard implements CanActivate {
  constructor(
    private authenticationFacade: AuthenticationFacade,
    private companyConfigFacade: CompanyConfigFacade,
    private navCtrl: NavController
  ) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([this.companyConfigFacade.isAnonymousBrowsing$, this.authenticationFacade.isAuthenticated$]).pipe(
      first(),
      map(([isAnonymous, isAuthenticated]) => {
        if (isAnonymous || isAuthenticated) {
          if (isAnonymous && !isAuthenticated) {
            return true;
          } else {
            this.authenticationFacade.loadAccountDetails(AccountDetailsFlowType.InApp);
            return true;
          }
        } else {
          this.navCtrl.navigateRoot(['/login']);
          return false;
        }
      }),
      catchError((err) => {
        this.navCtrl.navigateRoot(['/login']);
        return of(false);
      })
    );
  }
}
